export default function PHP_ob_end_flush() {
  return (
    <div>
      <h1>PHP_ob_end_flush</h1>
    </div>
  );
}
